import { render, staticRenderFns } from "./ProfileDocuments.vue?vue&type=template&id=56bea314&scoped=true&"
import script from "./ProfileDocuments.vue?vue&type=script&lang=js&"
export * from "./ProfileDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDocuments.vue?vue&type=style&index=0&id=56bea314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bea314",
  null
  
)

export default component.exports